import React from 'react';
import Aux from '../../../hoc/ReactAux';
import './LowerHeader.css';

const lowerHeader = props => (
  <Aux>
    <div className="lowerHeader">
      <span>{props.pageTitle}</span>
    </div>
  </Aux>
);

export default lowerHeader;



// WEBPACK FOOTER //
// ./src/components/Header/LowerHeader/LowerHeader.js